import React from 'react';
import '../../css/gardenManagerStylings/GardenManagerSidebarOverviewStyling.css';

const GardenManagerSidebarOverviewComponent = ({ garden }) => {

    // function to calculate the current overall health rating of the garden based on plant health ratings
    const calculateOverallGardenHealth = (garden) => {
        if (!garden?.plants || garden.plants.length === 0) {
            return null;
        }

        // Filter out plants that don't have health ratings (null/undefined)
        const plantsWithHealth = garden.plants.filter(plant =>
            plant.health_rating !== null && plant.health_rating !== undefined
        );

        if (plantsWithHealth.length === 0) {
            return null; // no plants have health ratings yet
        }

        // calculate average health rating
        const totalHealth = plantsWithHealth.reduce((sum, plant) => {
            return sum + plant.health_rating;
        }, 0);

        const averageHealth = totalHealth / plantsWithHealth.length;
        return Math.round(averageHealth * 10);
    }

    // function to grab the most recent garden watering date
    const getLastWateredDate = () => {
        if (!garden?.plants || garden.plants.length === 0) {
            return null;
        }

        // Filter out plants that have been watered (non-null last_watered)
        const wateredPlants = garden.plants.filter(plant => plant.last_watered !== null);

        if (wateredPlants.length === 0) {
            return null; // no plants have been watered yet
        }

        // Find most recent watered date
        const mostRecentDate = wateredPlants.reduce((latest, plant) => {
            const plantWateredDate = new Date(plant.last_watered);
            const latestDate = new Date(latest);
            return plantWateredDate > latestDate ? plant.last_watered : latest;
        }, wateredPlants[0].last_watered);

        return mostRecentDate;
    };

    const calculateHealthyPlants = (garden) => {
        if (!garden?.plants || garden.plants.length === 0) {
            return null;
        }

        // Filter out plants that don't have health ratings (null/undefined)
        const healthyPlants = garden.plants.filter(plant =>
            plant.health_rating !== null && plant.health_rating !== undefined && plant.health_rating > 5
        );

        return healthyPlants.length;
    }

    const calculateUnhealthyPlants = (healthyPlants, garden) => {
        if (!garden?.plants || garden.plants.length === 0 || healthyPlants === null) {
            return null;
        }

        return garden.plants.length - healthyPlants;
    }

    const overallGardenHealth = calculateOverallGardenHealth(garden);
    const lastWateredDate = getLastWateredDate(garden);
    const totalHealthyPlants = calculateHealthyPlants(garden);
    const totalUnhealthyPlants = calculateUnhealthyPlants(totalHealthyPlants, garden);

    return (
        <div className={`garden-manager-overview-component`}>

            <div className={`garden-manager-overview-entry`}>
                {overallGardenHealth ? (
                    <div className={`garden-overview-garden-health`} title={"Overall garden health"}>
                        {overallGardenHealth}%
                    </div>
                ) : (
                    <div className={`garden-overview-garden-health`}>Not Planted</div>
                )}

                {overallGardenHealth && (
                    <div className="garden-health-bar">
                        <div className="garden-health-bar-fill" style={{ width: `${overallGardenHealth}%` }}></div>
                    </div>
                )}
            </div>

            <div className={`garden-manager-overview-entry`}>
                {totalHealthyPlants ? (
                    <div className={`garden-overview-healthy-plants`}>{totalHealthyPlants} healthy plants</div>
                ) : (
                    <div className={`garden-overview-no-healthy-plants`} title={"No healthy plants in garden!"}>
                        Health Alert!
                    </div>
                )}
            </div>

            <div className={`garden-manager-overview-entry`}>
                {totalUnhealthyPlants ? (
                    <div className={`garden-overview-need-care-plants`}>{totalUnhealthyPlants} unhealthy plants</div>
                ) : (
                    <div className={`garden-overview-no-need-care-plants`} title={"No unhealthy plants!"}>
                        Garden is flourishing!
                    </div>
                )}
            </div>

            <div className={`garden-manager-overview-entry`}>
                {lastWateredDate ? (
                    <div className={`garden-overview-last-watered`} title={"Date garden was last watered"}>
                        {lastWateredDate}
                    </div>
                ) : (
                    <div className={`garden-overview-not-watered`}>Not watered yet</div>
                )}
            </div>

        </div>
    )
}

export default GardenManagerSidebarOverviewComponent;